import { render, staticRenderFns } from "./GiphyField.vue?vue&type=template&id=9b8e3e24&scoped=true"
import script from "./GiphyField.vue?vue&type=script&lang=js"
export * from "./GiphyField.vue?vue&type=script&lang=js"
import style0 from "./GiphyField.vue?vue&type=style&index=0&id=9b8e3e24&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b8e3e24",
  null
  
)

export default component.exports